import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { articles as rawArticles } from "../data/articles";

const sortByDateDesc = (items: typeof rawArticles) =>
  [...items].sort((a, b) => {
    const [da, ma, ya] = a.date.split(".").map(Number);
    const [db, mb, yb] = b.date.split(".").map(Number);
    return yb - ya || mb - ma || db - da;
  });

export const PublicationsPage: React.FC = () => {
  const sortedArticles = useMemo(() => sortByDateDesc(rawArticles), []);

  return (
    <main className="page">
      <section className="publications-hero">
        <div className="publications-hero__inner">
          <p className="eyebrow">Публикации</p>
          <h1>Все статьи</h1>
          <p className="publications-hero__subtitle">
            Полная подборка материалов по неврологии и психотерапии. Доступны для чтения на сайте.
          </p>
        </div>
      </section>

      <section className="publications-list">
        <div className="publications-list__inner">
          <div className="articles__grid">
            {sortedArticles.map((art) => (
              <article key={art.slug} className="article-card">
                <div className="article-card__media"></div>
                <div className="article-card__body">
                  <span className="article-card__date">{art.date}</span>
                  <h3>{art.title}</h3>
                  <p>{art.excerpt}</p>
                  <Link className="article-card__link" to={`/articles/${art.slug}`}>
                    Читать полностью
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};
